import React from 'react';
import {ThemeProvider as ReactThemeProvider} from '@unthinkable/react-theme';
import theme from '../../theme';

export const ThemeProvider = props => {
  const {children} = props || {};
  return <ReactThemeProvider {...theme}>{children}</ReactThemeProvider>;
};
